var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.parts.length > 0)?_c('div',_vm._l((_vm.parts),function(part,index){return _c('viewer-chartset-part',{key:'charset-pict-' + part,attrs:{"pictogramId":part}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }